<template>
	<el-dialog class="merge-viewer" :title="viewTitle" :visible.sync="visible" width="520px" append-to-body
		:before-close="onClose">
		<el-scrollbar class="merge-list">
			<div v-for="(r, i) in records" :key="i" class="merge-record">
				<head-image class="mr-avatar" :name="r.sendNickName" :size="32" :url="r.headImage"></head-image>
				<div class="mr-body">
					<div class="mr-head">
						<span class="mr-name">{{ r.sendNickName }}</span>
						<span class="mr-time">{{ $date.toTimeText(r.sendTime) }}</span>
					</div>
					<div class="mr-content">
						<span v-if="isText(r)" class="mr-text" v-html="htmlText(r)"></span>
						<img v-else-if="isImage(r)" class="mr-image" :src="thumb(r)" draggable="false" @dragstart.prevent @click="openImage(r)" />
						<div v-else-if="isVideo(r)" class="mr-video" @click="openVideo(r)">
							<img v-if="thumb(r)" :src="thumb(r)" draggable="false" @dragstart.prevent />
							<span v-else class="mr-video-empty">视频</span>
							<i class="el-icon-video-play"></i>
						</div>
						<div v-else-if="isFile(r)" class="mr-file">
							<i class="el-icon-document"></i>
							<span class="mr-file-name">{{ fileName(r) }}</span>
						</div>
						<audio v-else-if="isAudio(r)" controls :src="audioUrl(r)"></audio>
						<span v-else-if="isMerge(r)" class="mr-text">[聊天记录]</span>
						<span v-else class="mr-text">{{ preview(r) }}</span>
					</div>
				</div>
			</div>
			<div v-if="!records.length" class="merge-empty">暂无聊天记录</div>
		</el-scrollbar>
	</el-dialog>
</template>

<script>
import HeadImage from "../common/HeadImage.vue";
export default {
	name: "mergeMessageViewer",
	components: { HeadImage },
	props: {
		dialogVisible: {
			type: Boolean,
			default: false
		},
		data: {
			type: Object,
			default: null
		}
	},
	methods: {
		onClose() {
			this.$emit("close");
		},
		contentData(r) {
			try {
				return JSON.parse(r.content);
			} catch (e) {
				return {};
			}
		},
		isText(r) {
			return r.type == this.$enums.MESSAGE_TYPE.TEXT;
		},
		isImage(r) {
			return r.type == this.$enums.MESSAGE_TYPE.IMAGE;
		},
		isVideo(r) {
			return r.type == this.$enums.MESSAGE_TYPE.VIDEO;
		},
		isFile(r) {
			return r.type == this.$enums.MESSAGE_TYPE.FILE;
		},
		isAudio(r) {
			return r.type == this.$enums.MESSAGE_TYPE.AUDIO;
		},
		isMerge(r) {
			return r.type == this.$enums.MESSAGE_TYPE.MERGE;
		},
		htmlText(r) {
			let text = this.$str.html2Escape(r.content);
			text = this.$url.replaceURLWithHTMLLinks(text, '');
			return this.$emo.transform(text, 'emoji-normal');
		},
		thumb(r) {
			const d = this.contentData(r);
			return d.thumbUrl || d.originUrl || '';
		},
		fileName(r) {
			return this.contentData(r).name || '文件';
		},
		audioUrl(r) {
			return this.contentData(r).url || '';
		},
		preview(r) {
			return this.$msgUtil.previewContent(r);
		},
		openImage(r) {
			const d = this.contentData(r);
			this.$eventBus.$emit("openFullImage", d.originUrl || d.thumbUrl);
		},
		openVideo(r) {
			const d = this.contentData(r);
			this.$eventBus.$emit("openFullVideo", d.url);
		}
	},
	computed: {
		visible: {
			get() {
				return this.dialogVisible;
			},
			set(val) {
				if (!val) {
					this.onClose();
				}
			}
		},
		viewTitle() {
			return (this.data && this.data.title) || '聊天记录';
		},
		records() {
			return (this.data && this.data.records) || [];
		}
	}
}
</script>

<style lang="scss" scoped>
.merge-viewer {
	.merge-list {
		max-height: 520px;

		.merge-record {
			display: flex;
			align-items: flex-start;
			padding: 8px 4px;

			& + .merge-record {
				border-top: 1px solid var(--im-border-color-light, #f0f0f0);
			}

			.mr-avatar {
				flex-shrink: 0;
				margin-right: 10px;
			}

			.mr-body {
				flex: 1;
				min-width: 0;

				.mr-head {
					display: flex;
					align-items: center;
					margin-bottom: 4px;

					.mr-name {
						font-size: 13px;
						font-weight: 600;
						color: var(--im-color-primary);
						margin-right: 8px;
					}

					.mr-time {
						font-size: 12px;
						color: var(--im-text-color-light);
					}
				}

				.mr-content {
					font-size: 14px;
					color: var(--im-text-color);
					word-break: break-word;
					white-space: pre-wrap;

					.mr-text {
						line-height: 20px;
					}

					.mr-image {
						max-width: 160px;
						max-height: 160px;
						border-radius: 6px;
						cursor: pointer;
						object-fit: cover;
					}

					.mr-video {
						position: relative;
						display: inline-flex;
						align-items: center;
						justify-content: center;
						width: 160px;
						height: 120px;
						border-radius: 6px;
						overflow: hidden;
						background: #000;
						cursor: pointer;

						img {
							width: 100%;
							height: 100%;
							object-fit: cover;
						}

						.mr-video-empty {
							color: #fff;
							font-size: 13px;
						}

						.el-icon-video-play {
							position: absolute;
							font-size: 32px;
							color: #fff;
							text-shadow: 0 0 4px rgba(0, 0, 0, 0.6);
						}
					}

					.mr-file {
						display: inline-flex;
						align-items: center;
						padding: 8px 12px;
						border-radius: 6px;
						background: var(--im-background-active);

						.el-icon-document {
							font-size: 24px;
							color: var(--im-color-primary);
							margin-right: 8px;
						}

						.mr-file-name {
							max-width: 260px;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
						}
					}

					audio {
						height: 40px;
					}
				}
			}
		}

		.merge-empty {
			padding: 40px 0;
			text-align: center;
			color: var(--im-text-color-light);
		}
	}
}
</style>
